export default __webpack_public_path__ + "static/media/Major Rune Stone of the Chaos Agent.b2f4ba2c.jpg";